import './Job.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowsH,
  faBars,
  faCube,
  faCutlery,
  faFlask,
  faSnowflake,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

// General Job Component
const Job = ({ job }) => {
  const navigate = useNavigate();

  const jobReference = job[0]?.job?.jobReference;
  const quantity = job?.length;
  const type = job?.every(pkg => pkg.packageType.shortName == job[0]?.packageType?.shortName)
    ? job[0]?.packageType?.shortName
    : 'pkg';

  const weight = job?.map(pkg => pkg.grossWeightKg).reduce((a, b) => a + b, 0);
  const cubicMetres = job
    .map(pkg => Number(pkg.cubicMetres))
    .reduce((a, b) => a + b, 0)
    .toFixed(2);

  const widthSame = job?.every(pkg => pkg.widthCm == job[0]?.widthCm);
  const heightSame = job?.every(pkg => pkg.heightCm == job[0]?.heightCm);
  const lengthSame = job?.every(pkg => pkg.lengthCm == job[0]?.lengthCm);

  const dimensions =
    widthSame && heightSame && lengthSame
      ? `${job[0]?.lengthCm || '?'}x${job[0]?.widthCm || '?'}x${job[0]?.heightCm || '?'} cm`
      : '(various dims)';

  const jobDetails = job[0]?.job;
  const hazardous = jobDetails.cargoHazardous;
  const fullLoad = jobDetails.fullLoad;
  const doNotStack = jobDetails.doNotStack;
  const foodstuffs = jobDetails.commodityCategory?.foodstuffs;
  const temperatureControlled = jobDetails.temperatureControlled;
  const waste = jobDetails.commodityCategory?.waste;
  const overlength = jobDetails.overlength;

  return (
    <div className="job_container" onClick={() => navigate(`/jobs/${jobDetails.id}`)}>
      <div className="job_row">
        <div className="job_reference">{jobReference}</div>
        <div className="job_quantity_type">
          {quantity} {type}
        </div>
        <div className="job_weight">{weight} kg</div>
        <div className="job_cubic_metres">{cubicMetres}m³</div>
      </div>
      <div className="job_row">
        <div className="job_symbol_row">
          {hazardous && (
            <div className="job_symbol hazardous">
              <FontAwesomeIcon icon={faFlask} data-testid="hazard_icon" />
            </div>
          )}
          {fullLoad && (
            <div className="job_symbol full_load">
              <FontAwesomeIcon icon={faCube} data-testid="full_load_icon" />
            </div>
          )}
          {doNotStack && (
            <div className="job_symbol do_not_stack">
              <FontAwesomeIcon icon={faBars} data-testid="do_not_stack_icon" />
            </div>
          )}
          {foodstuffs && (
            <div className="job_symbol foodstuffs">
              <FontAwesomeIcon icon={faCutlery} data-testid="foodstuffs_icon" />
            </div>
          )}
          {temperatureControlled && (
            <div className="job_symbol temp_control">
              <FontAwesomeIcon icon={faSnowflake} data-testid="temperature_icon" />
            </div>
          )}
          {waste && (
            <div className="job_symbol waste">
              <FontAwesomeIcon icon={faTrash} data-testid="waste_icon" />
            </div>
          )}
          {overlength && (
            <div className="job_symbol overlength">
              <FontAwesomeIcon icon={faArrowsH} data-testid="overlength_icon" />
            </div>
          )}
        </div>
        <div className="job_dimensions">{dimensions}</div>
      </div>
    </div>
  );
};

Job.propTypes = {
  job: PropTypes.object,
};

export default Job;
